import React from "react";

const rc = {
  EXECUTOR: "badge-executor",
  OWNER: "badge-owner",
  APPROVER: "badge-approver",
};

const Badge = ({
  children,
  className,
}) => (
  <span
    className={`my-work-badge ${
      className || ""
    }`}
  >
    {children}
  </span>
);

const pc = (v) =>
  v === "HIGH"
    ? "badge-high"
    : v === "MEDIUM"
    ? "badge-medium"
    : "badge-low";

const sc = (v) =>
  v === "CLOSED"
    ? "badge-closed"
    : v === "WAITING_FOR_APPROVAL"
    ? "badge-approval"
    : v === "IN_PROGRESS"
    ? "badge-progress"
    : "badge-open";

const slc = (v) =>
  v === "BREACHED" ||
  v === "COMPLETED_AFTER_BREACH"
    ? "badge-sla-breached"
    : v === "WARNING"
    ? "badge-sla-warning"
    : "badge-sla-good";

export default function MyWorkTable({
  rows,
  loading,
  onAction,
  onComments,
}) {
  return (
    <div className="my-work-table-card">

      <div className="my-work-table-head">
        <h5>
          My Work
        </h5>

        <span className="count">
          {rows.length} item(s)
        </span>
      </div>

      <div className="table-responsive">

        <table className="table my-work-table">

          <thead>

            <tr>

              {[
                "Work No.",
                "Title / Template",
                "My Role",
                "Priority",
                "Status",
                "SLA Status",
                "Due Date / Time",
                "Escalation",
                "Assigned By",
                "Action",
              ].map(
                (x) => (
                  <th key={x}>
                    {x}
                  </th>
                )
              )}

            </tr>

          </thead>

          <tbody>

            {loading && (
              <tr>

                <td
                  colSpan="10"
                  className="text-center p-5"
                >

                  <div className="spinner-border spinner-border-sm text-primary" />

                </td>

              </tr>
            )}

            {!loading &&
              !rows.length && (
                <tr>

                  <td
                    colSpan="10"
                    className="text-center text-muted p-5"
                  >
                    No work found
                  </td>

                </tr>
              )}

            {!loading &&
              rows.map(
                (r) => (
                  <tr key={r.id}>

                    {/* WORK NO. */}

                    <td>

                      <span className="work-no">
                        {r.work_no}
                      </span>

                    </td>

                    {/* TITLE / TEMPLATE */}

                    <td>

                      <div className="work-title">
                        {r.title}
                      </div>

                      <div className="work-subtitle">
                        {r.template_name ||
                          r.work_mode}
                      </div>

                    </td>

                    {/* MY ROLE */}

                    <td>

                      {r.my_role.map(
                        (x) => (
                          <Badge
                            key={x}
                            className={
                              rc[x] ||
                              "badge-open"
                            }
                          >
                            {x[0] +
                              x
                                .slice(1)
                                .toLowerCase()}
                          </Badge>
                        )
                      )}

                    </td>

                    {/* PRIORITY */}

                    <td>

                      <Badge
                        className={pc(
                          r.priority
                        )}
                      >
                        {r.priority}
                      </Badge>

                    </td>

                    {/* STATUS */}

                    <td>

                      <Badge
                        className={sc(
                          r.status
                        )}
                      >
                        {r.status.replaceAll(
                          "_",
                          " "
                        )}
                      </Badge>

                    </td>

                    {/* SLA */}

                    <td>

                      <Badge
                        className={slc(
                          r.sla_status
                        )}
                      >

                        <i
                          className={`fas ${
                            r.sla_status ===
                            "BREACHED"
                              ? "fa-exclamation-triangle"
                              : r.sla_status ===
                                "WARNING"
                              ? "fa-clock"
                              : "fa-check-circle"
                          } me-1`}
                        />

                        {r.sla_label}

                      </Badge>

                      <div className="work-subtitle">
                        {r.sla_remaining}
                      </div>

                    </td>

                    {/* DUE DATE */}

                    <td
                      className={
                        r.sla_status ===
                        "BREACHED"
                          ? "text-danger fw-semibold"
                          : ""
                      }
                    >
                      {r.due_date ||
                        "—"}
                    </td>

                    {/* ESCALATION */}

                    <td>

                      {r.escalation ? (

                        <Badge
                          className="badge-sla-breached"
                        >
                          {r.escalation}
                        </Badge>

                      ) : (
                        "—"
                      )}

                    </td>

                    {/* ASSIGNED BY */}

                    <td>
                      {r.assigned_by ||
                        "—"}
                    </td>

                    {/* ACTION */}

                    <td>

                        <div className="d-flex align-items-center gap-1">

                            {/* Existing Action */}

                            <button
                            type="button"
                            className="btn btn-sm btn-light border"
                            onClick={() =>
                                onAction(r)
                            }
                            title="Open Work"
                            >
                            <i className="fas fa-chevron-right text-primary" />
                            </button>

                            {/* Comment */}

                            <button
                            type="button"
                            className="btn btn-sm btn-light border"
                            onClick={() =>
                                onComments(r)
                            }
                            title="Comments"
                            >
                            <i className="fas fa-comments text-secondary" />
                            </button>

                        </div>

                        </td>

                  </tr>
                )
              )}

          </tbody>

        </table>

      </div>

      <div className="my-work-pagination">

        <span>
          Showing 1 to{" "}
          {rows.length} of{" "}
          {rows.length} entries
        </span>

        <div className="d-flex gap-1">

          <button
            className="btn btn-light border"
            disabled
          >
            «
          </button>

          <button
            className="btn btn-light border"
            disabled
          >
            ‹
          </button>

          <button className="btn btn-primary">
            1
          </button>

          <button
            className="btn btn-light border"
            disabled
          >
            ›
          </button>

          <button
            className="btn btn-light border"
            disabled
          >
            »
          </button>

        </div>

      </div>

    </div>
  );
}